module.exports = __webpack_public_path__ + "static/media/FilesFolder.f3c13d0a.svg";